import React from "react";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import { Form } from "antd";
import SpecialistForm from "./SpecialistForm";
const EditInvite = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_Invite_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit Specialist"
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editSpecialist"
        ModalName="Edit_Invite_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_Invite_Modal ? Edit_Invite_Modal : false}
        initialValues={initialValues}
        width={450}
        recordName="specialistList"
        form={form}
      >
        <SpecialistForm />
      </FormModal>
    </div>
  );
};

export default EditInvite;
